import { connect }  from 'react-redux';
import Locale       from '../../../locale';
import Back         from './back.jsx';

export default connect(
    // mapStateToProps
    state => {
        return {
            backLabel: Locale.getString( state, 'common.button.backLabel' )
        };
    },
    // mapDispatchToProps
    {}
)( Back );
